import { render, staticRenderFns } from "./MaterialsOrderSummary.vue?vue&type=template&id=4ec62b76&scoped=true"
import script from "./MaterialsOrderSummary.vue?vue&type=script&lang=js"
export * from "./MaterialsOrderSummary.vue?vue&type=script&lang=js"
import style0 from "./MaterialsOrderSummary.vue?vue&type=style&index=0&id=4ec62b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec62b76",
  null
  
)

export default component.exports